import { render, staticRenderFns } from "./FaceDirectionResultEffectFaceDown2.vue?vue&type=template&id=76fbbda0&"
import script from "./FaceDirectionResultEffectFaceDown2.vue?vue&type=script&lang=ts&"
export * from "./FaceDirectionResultEffectFaceDown2.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports